import { UserCallAvailability } from "@redotech/redo-model/support/voice/voice-types";
import { z } from "zod";

export const createCallAvailability = {
  input: z.object({ availabilityStatus: z.nativeEnum(UserCallAvailability) }),
  output: z.object({ status: z.number() }),
};
